import { MainPointOutType } from '../../@types/rule-type';
export default class AIErrorPoints {
    result;
    text;
    constructor(result, text) {
        this.result = result;
        this.text = text;
        this.result = result;
        this.text = text;
    }
    createProofreadingPoints() {
        const arrayFotGpt = this.text.split('\n').map((text, index) => {
            return {
                beforeTextLength: index === 0 ? 0 : this.text.split('\n').slice(0, index).join('\n').length,
                line: index + 1,
                text: text
            };
        });
        const errorPoints = [];
        if (typeof this.result === 'string') {
            return [];
        }
        let order = 0;
        for (const res of this.result) {
            const targetLine = arrayFotGpt.find((line) => line.line === res.line);
            if (!targetLine)
                continue;
            const checkTargetIndex = targetLine?.text.indexOf(res.text);
            if (checkTargetIndex === -1)
                continue;
            const targetIndex = checkTargetIndex + targetLine?.beforeTextLength;
            errorPoints.push({
                type: MainPointOutType.AI,
                index: res.line === 1 ? targetIndex : targetIndex + 1,
                order: order,
                range: res.text.length - 1,
                resultHtmlInfo: {
                    text: res.text,
                    reason: res.reason
                },
                uniqueId: `${res.line}-${res.text}`
            });
            order++;
        }
        return errorPoints;
    }
}
